import { render, staticRenderFns } from "./list_product.vue?vue&type=template&id=468c119c&scoped=true"
import script from "./list_product.vue?vue&type=script&lang=js"
export * from "./list_product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468c119c",
  null
  
)

export default component.exports